
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/fan-register",
      function () {
        return require("private-next-pages/auth/fan-register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/fan-register"])
      });
    }
  